import { Action } from '@ngrx/store';

import { HideLoader } from '../../../../shared/decorators/hide-loader';
import { ShowLoader } from '../../../../shared/decorators/show-loader';
import { Language } from '../../language/language.model';

export enum LanguageActionTypes {
  LoadLanguages = '[Languages] Load',
  LoadLanguagesSuccess = '[Languages] Load success',
  LoadLanguagesFail = '[Languages] Load fail',
}

@ShowLoader()
export class LoadLanguages implements Action {
  readonly type = LanguageActionTypes.LoadLanguages;
}
@HideLoader(LanguageActionTypes.LoadLanguages)
export class LoadLanguagesSuccess implements Action {
  readonly type = LanguageActionTypes.LoadLanguagesSuccess;
  constructor(public payload: Language[]) { }
}
@HideLoader(LanguageActionTypes.LoadLanguages)
export class LoadLanguagesFail implements Action {
  readonly type = LanguageActionTypes.LoadLanguagesFail;
  constructor(public payload: string) { }
}


export type LanguageActions = LoadLanguages | LoadLanguagesSuccess | LoadLanguagesFail;
